import React from "react";

const RecallSelectiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.001"
      height="24.001"
      viewBox="0 0 24.001 24.001"
    >
      <path
        id="db57"
        d="M188.265,178.679a9.592,9.592,0,1,0,5.864,17.16l6.476,6.469h0a1.2,1.2,0,1,0,1.7-1.691l-6.478-6.479a9.573,9.573,0,0,0-7.562-15.459Zm0,2.4a7.193,7.193,0,1,1-7.194,7.188A7.165,7.165,0,0,1,188.265,181.078Zm-.016,2.382h0a1.2,1.2,0,0,0-1.187,1.213v2.4h-2.4q-.057,0-.115,0a1.2,1.2,0,0,0,.115,2.4h2.4v2.4a1.2,1.2,0,1,0,2.4,0v-2.4h2.4a1.2,1.2,0,1,0,0-2.4h-2.4v-2.4a1.2,1.2,0,0,0-1.211-1.213Z"
        transform="translate(-178.67 -178.679)"
        fill="#404040"
      />
    </svg>
  );
};

export default RecallSelectiveIcon;
